import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FullModeService } from 'src/app/services/full-mode.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {
  classHeader = 'header2';
  logoImg=`../../../assets/imgs/logo/se2in_logo.png`;
  loginButton:boolean = false;
  titleSectionProp: any = {
    class: 'text-center iq-title-box-2 wow fadeInUp',
    title: '',
    titleIcon: ''
  };

  List: any[] = [
    {
      title: 'AI_GENERATED_SOFTWARE' ,
      image : '../../assets/images/se-icons/ai-programming.png',
      services: [ { title : 'COST_EFFECTIVE_AI_PROGRAMMING' },{ title :'OUR_DEVELOPERS_SUPERVISE' } ],
      desc: 'AI_GENERATED_SOFTWARE_DESC'
    },
    {
      title: 'PEOPLE_GENERATED_SOFTWARE' ,
      image : '../../assets/images/se-icons/monitor.png',
      services: [ { title : 'APP_REVIEW_DESCRIPTION' },{ title :'AI_LEARNING_DESCRIPTION' } ],
      desc: 'PEOPLE_GENERATED_SOFTWARE_DESCRIPTION'
    },
    {
      title: 'ADMINISTRATION_BY_EXPERTS' ,
      image : '../../assets/images/se-icons/platforms2.png',
      services: [ { title : 'MAINTENENCE_DESCRIPTION' },{ title :'AVAILABILITY_DESCRIPTION' } ],
      desc: 'ADMINISTRATION_BY_EXPERTS_DESCRIPTION'
    },
    {
      title: 'AI_CHAT_BOT',
      image : '../../assets/images/se-icons/database.png',
      services: [ { title : 'AI_CHAT_DESCRIPTION' },{ title :'EXPERT_CHAT_DESCRIPTION' } ],
      desc: 'CHAT_SYSTEM_DESCRIPTION'
    },
    {
      title: 'BUSINESS_LOGIC_INTERFACE' ,
      image : '../../assets/images/se-icons/designer-web.png',
      services: [ { title : 'GENERATE_APPS_DESCRIPTION' },{ title :'GENERATE_DOCS_DESCRIPTION' } ],
      desc: 'BUSINESS_LOGIC_DESCRIPTION'
    },
    {
      title: 'OUR_APPLICATIONS' ,
      image : '../../assets/images/se-icons/devtools.png',
      services: [ { title : 'DESIGNER_AND_CREATOR_DESCRIPTION' },{ title :'BACKOFFICE_DESCRIPTION' } ],
      desc: 'TOOLS_DESCRIPTION'
    }
  ]

  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute,
    public fullModeService:FullModeService
  ) { }

  ngOnInit(): void { }

}
